import { GridColumn } from '@entity-framework/entity-grid/state/entity-grid-column';
import { columnFormatters } from '@utils/display-formatters';
import { CellClassParams } from '@ag-grid-community/core';

const getRowErrorClass = (params: CellClassParams) => {
  return params.data?.errorDescription ? 'error-row-cell' : '';
};

export const pensionContributionsGridColumns = (): GridColumn[] => [
  {
    propertyName: 'employeeId',
    headerLabel: 'Employee ID',
    propertyType: 'text',
    sortable: true,
    colDefOverrides: {
      flex: 1,
      minWidth: 120,
      cellClass: getRowErrorClass
    }
  },
  {
    propertyName: 'employeeName',
    headerLabel: 'Employee name',
    propertyType: 'text',
    sortable: true,
    colDefOverrides: {
      flex: 2,
      minWidth: 150,
      cellClass: getRowErrorClass
    }
  },
  {
    propertyName: 'errorDescription',
    headerLabel: 'Error description',
    propertyType: 'text',
    sortable: true,
    formatForDisplay: (value: string) => value || '-',
    colDefOverrides: {
      flex: 3,
      minWidth: 200,
      cellClass: (params: CellClassParams) => {
        const baseClass = getRowErrorClass(params);
        return params.value ? `${baseClass} error-text` : baseClass;
      }
    }
  },
  {
    propertyName: 'periodEarnings',
    headerLabel: 'Period earnings',
    propertyType: 'number',
    sortable: true,
    alignRight: true,
    formatForDisplay: (value: number) => columnFormatters.currency(value, 'GBP'),
    colDefOverrides: {
      flex: 1.5,
      minWidth: 130,
      type: 'numericColumn',
      cellClass: getRowErrorClass
    }
  },
  {
    propertyName: 'employeeContribution',
    headerLabel: 'Employee contribution',
    propertyType: 'number',
    sortable: true,
    alignRight: true,
    formatForDisplay: (value: number) => columnFormatters.currency(value, 'GBP'),
    colDefOverrides: {
      flex: 1.8,
      minWidth: 150,
      type: 'numericColumn',
      cellClass: getRowErrorClass
    }
  },
  {
    propertyName: 'employerContribution',
    headerLabel: 'Employer contribution',
    propertyType: 'number',
    sortable: true,
    alignRight: true,
    formatForDisplay: (value: number) => columnFormatters.currency(value, 'GBP'),
    colDefOverrides: {
      flex: 1.8,
      minWidth: 150,
      type: 'numericColumn',
      cellClass: getRowErrorClass
    }
  },
  {
    propertyName: 'total',
    headerLabel: 'Total',
    propertyType: 'number',
    sortable: true,
    alignRight: true,
    formatForDisplay: (value: number) => columnFormatters.currency(value, 'GBP'),
    textBold: () => true,
    colDefOverrides: {
      flex: 1.2,
      minWidth: 110,
      type: 'numericColumn',
      cellClass: getRowErrorClass
    }
  },
  {
    propertyName: 'pensionGroup',
    headerLabel: 'Pension group',
    propertyType: 'text',
    sortable: true,
    colDefOverrides: {
      flex: 1.5,
      minWidth: 130,
      cellClass: getRowErrorClass
    }
  },
  {
    propertyName: 'zeroContributionsReason',
    headerLabel: 'Zero contributions reason',
    propertyType: 'text',
    sortable: true,
    formatForDisplay: (value: string) => value || '-',
    colDefOverrides: {
      flex: 2,
      minWidth: 180,
      cellClass: getRowErrorClass
    }
  }
];
